export const DEFAULT_CONTENT_LANGUAGE = "en";

/** Supported brand content languages: code → English display name. Extend here. */
export const CONTENT_LANGUAGE_NAMES: Record<string, string> = {
  en: "English",
  es: "Spanish",
};

export const SUPPORTED_CONTENT_LANGUAGES: string[] = Object.keys(CONTENT_LANGUAGE_NAMES);

export function isSupportedContentLanguage(code: string): boolean {
  return Object.prototype.hasOwnProperty.call(CONTENT_LANGUAGE_NAMES, code);
}

export function contentLanguageName(code: string): string {
  return CONTENT_LANGUAGE_NAMES[code] ?? code;
}
